import type { DocEntityTypeToValueType } from "building-types/entities/docEntityTypeToValueType";
import type { DocEntityNode } from "./docEntityNode";

export function docEntityGroupNodeIs(node: DocEntityNode, field: keyof DocEntityTypeToValueType["GROUP"]): boolean {
  const entity = node.getDocEntity();

  if (!entity) {
    return false;
  }

  return !!entity[field as any];
}
